import i18n from 'i18next';
import { initReactI18next } from 'react-i18next';
import de from './de/translation.json';
import en from './en/translation.json';
import fr from './fr/translation.json';

const resources = {
  de: { translation: de },
  en: { translation: en },
  fr: { translation: fr },
};

const defaultNS = 'translation';

// Function to get language from cookie
const getCookieValue = (name: string): string | undefined => {
  const nameEQ = name + '=';
  const ca = document.cookie.split(';');
  for (const cookie of ca) {
    const c = cookie.trim();
    if (c.startsWith(nameEQ)) {
      return c.substring(nameEQ.length);
    }
  }
  return undefined;
};

// Determine initial language from various sources
const getInitialLanguage = (): string => {
  // 1. Check cookie first
  const cookieLanguage = getCookieValue('Brz365.language');
  if (cookieLanguage && (cookieLanguage === 'de' || cookieLanguage === 'en')) {
    return cookieLanguage;
  }

  // 2. Check localStorage as fallback
  const localStorageLanguage = localStorage.getItem('Brz365.language');
  if (
    localStorageLanguage &&
    (localStorageLanguage === 'de' || localStorageLanguage === 'en')
  ) {
    return localStorageLanguage;
  }

  // 3. Check browser language
  const browserLanguage = navigator.language.toLowerCase();
  if (browserLanguage.startsWith('de')) {
    return 'de';
  }
  if (browserLanguage.startsWith('en')) {
    return 'en';
  }

  // 4. Default fallback
  return 'de';
};

const i18nInstance = i18n.createInstance();
i18nInstance.use(initReactI18next).init({
  fallbackLng: 'de',
  lng: getInitialLanguage(),
  debug: false,
  defaultNS,
  resources,
  interpolation: {
    escapeValue: false, // not needed for react as it escapes by default
  },
});

export default i18nInstance;
